export default __webpack_public_path__ + "static/media/LAS0090.34I107085_-17466_0.da01e8d9.jpg";